var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActionTrackSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0011C0 4.47764 4.47763 0 10.0011 0H37.9988C43.5223 0 47.9999 4.47763 47.9999 10.0011V37.9988C47.9999 43.5223 43.5223 47.9999 37.9988 47.9999H10.0011C4.47764 47.9999 0 43.5223 0 37.9988V10.0011Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9935 30.9996C27.4118 30.9996 30.9935 27.4179 30.9935 22.9996C30.9935 18.5814 27.4118 14.9996 22.9935 14.9996C18.5753 14.9996 14.9935 18.5814 14.9935 22.9996C14.9935 27.4179 18.5753 30.9996 22.9935 30.9996Z",
    stroke: "white",
    strokeWidth: 1.99978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.994 32.9988L28.6935 28.6984",
    stroke: "white",
    strokeWidth: 1.99978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActionTrackSearch);
export default __webpack_public_path__ + "static/media/dashboard-action-track-search.c05d0db33981edc2168087ee98e58ed7.svg";
export { ForwardRef as ReactComponent };